import GetTheEnergyPalAdvantage from '@/components/FeatureSection/GetTheEnergyPalAdvantage';
import WeAreGrowing from '@/components/FeatureSection/WeAreGrowing';
// import RollingFormSection from '@/components/FormSection/RollingFormSection';
import ImageHero from '@/components/Hero/ImageHero';
import HorizontalLeadFormSection from '@/components/LeadForm/HorizontalLeadFormSection';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
// import HeroImage from '@/images/why-energypal/EnergyPal-glowing-customer-solar-reviews.webp';
import HeroImage from 'images/hero/family-home.jpeg';
import MetaTags from '@/components/Head/MetaTags';
// import PrimaryHero from '@/components/Hero/PrimaryHero';

export default function Page() {
  return (
    <>
      <MetaTags
        title={`Why Choose EnergyPal for Home Solar? Discover Our Expertise`}
        // keywords={"home battery systems"}
        description={`Discover why EnergyPal is the best choice for your solar needs. Explore our expertise, resources, and commitment to customer satisfaction.`}
      />
      <ImageHero
        imageSrc={HeroImage}
        imageAlt="Why EnergyPal?"
        supTitle="THE BEST HOME SOLAR SHOPPING EXPERIENCE"
        title="You get more with EnergyPal"
        subTitle="Nobody has more industry-leading home solar &amp; battery packages, provided at exceptional value, than EnergyPal, with our unbiased consultative advisors keeping your best interests in mind. "
      />
      <HorizontalLeadFormSection />
      <GetTheEnergyPalAdvantage />
      <WeAreGrowing />
      <VerticalLeadFormSection className="border-b bg-gray-50" />
    </>
  );
}
